import { IEnvironment } from "@models/common/environment.model";

export const environment: IEnvironment = {
    version: '87804328b5c74bd55788edb582c1e58f16c7ceff',
    production: false,
    kinde_client_id: "358b53d1676848ad81700713491eb849",
    kinde_url: "https://login.pravo.green",
    api_url: "https://api.pravo.green",
    signalR_url: "https://signalr.pravo.green/signalrHub",
    sidebarBackgroundColor: '#1F3832',
    sidebarBackgroundColorHover: '#165f3e',
};
